export const serviceDescription = [
  'Global Health Solutions (“GHS”) has been procured by Peel Regional Police (“PRP”) to provide COVID-19 Online Supervised Rapid Antigen Testing clinics via Zoom video conferencing as part of the PRP COVID-19 Rapid Testing Program (“Program”).',

  'Your personal information (including personal health information) will be collected pursuant to applicable privacy law.',
];

export const ConsentAndAuthorization = [
  {
    description:
      'I hereby freely consent to permit GHS (and its Third-Party Service Provider or Third-Party Physician, where applicable) to collect, use, retain, and disclose my personal information for administering services related to the Program. I agree that my personal health information may be used for the following purposes:',
    list: [
      'ensuring the effective operation of the Program;',
      'providing information to PRP’s Occupational Health & Safety Unit about a positive COVID-19 test result;',
      'ensuring compliance with GHS’s privacy policy and data handling requirements;',
      'reporting, where required by law, any positive COVID-19 test results to the applicable provincial public health authority.',
    ],
  },
  {
    description:
      'I understand that if my test indicates I am positive for COVID-19, I will be contacted by the PRP Occupational Health & Safety Unit for follow-up. Additionally, I understand that GHS may also notify the PRP OHS of the positive test result for the purpose of ensuring a safe work environment.',
  },
  {
    description:
      'I understand and agree that if my test indicates I am positive for COVID-19, I am required to conduct an RT-PCR COVID-19 test. More information will be provided by the PRP Occupational Health & Safety Unit.',
  },
  {
    description:
      'Notwithstanding, my personal health information will not be disclosed except as required to support the operation of this Program or as required by applicable law or directive of any relevant public authority related to the COVID-19 pandemic.',
  },
  {
    description:
      'I have read and understood the information contained in this consent including how my information will be collected, used and disclosed by GHS (including any Third-Party Service Provider or Third-Party Physician) and am aware of the risks or benefits of consenting, or refusing to consent.',
  },
];
